import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { Add, Edit } from '@mui/icons-material';

import FormikControl from '../../../../../components/FormikControl/FormikControl';
import taskServices from '../taskServices';
import { useAlert } from '../../../../../context/AlertContext';
import { useAppData } from '../../../../../context/AppDataContext';
import TaskDetails from './TaskDetails';



function ProjectTaskForm({data,callBack,projectId }) {

    const {AppAlert} = useAlert();
    const {masters,projectDD} = useAppData();
    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);

    const initialValues = {        
        projectId:projectId,
        title:"",
        details:"",
        
    }

    const updateData = ()=>{
        let autoFill = {
            id:data.id,
            projectId:data.projectId,
            title:data.title,
            details:data.details,
            
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const validationRule = Yup.object({
        projectId:Yup.string().required("Required"),
        title:Yup.string().required("Required"),
        //details:Yup.string().required("Required"),
    });

    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const onSubmit = (values, onSubmitProps) => {
        taskServices.save(values).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            callBack();
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-outline-primary" onClick={addNew} ><Add/> Add New Task</button>     
                </Tooltip>
            }
            {data &&
                <Tooltip title="Update">
                    <IconButton onClick={updateData} style={{padding:"0px"}}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="md"
                aria-describedby="alert-dialog-slide-description"
            >

                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik.values);
                            return (
                                <Form>
                                    <DialogTitle>{"Task"}</DialogTitle>
                                    <DialogContent>
                                            <div className="row p-3">
                                                <div className="col-md-12 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Title" name="title" 
                                                    />
                                                </div>

                                                <div className="col-md-12 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" multiline={true} rows={4}
                                                        label="Details" name="details" 
                                                    />
                                                </div>
                                               
                                            </div>
                                           
                                        <div className="row mt-3">
                                            <div className='col-md-12'>
                                                {savingInProgress ?
                                                    <LinearProgress/>
                                                    :
                                                    <>
                                                        <button className="btn btn-primary float-end" type="submit">Save</button>
                                                        <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                                    </>
                                                }
                                            </div>
                                            <div className='col-md-12'>
                                                { /* JSON.stringify(formik) */  }
                                            </div>
                                        </div>
                                    </DialogContent>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>

        </>
    )
}

export default ProjectTaskForm